// Import helpers
import { projectLanguages } from 'translations/helpers';

export const defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE;

export const languagesOptions = projectLanguages.map((lang) => ({
	name: lang.toUpperCase(),
	value: lang
}));

export const hasSeveralLanguages = projectLanguages.length > 1;
